import apiConfig from "constants/apiConfig"
import { LoginPayload, LoginResponse } from "types/auth";
import { UserProfileResponse } from "types/user";
import axiosClient from "utils/axiosClient"

export const generateLoginOTP = async (data: {username: string}) : Promise<boolean> => {
    const response = await axiosClient.post(apiConfig.GENERATE_LOGIN_OTP.url, data);
    return !!response.data.status;
}

export const login = async (payload: LoginPayload) : Promise<LoginResponse> => {
    const response = await axiosClient.post(apiConfig.LOGIN.url, payload);
    return response.data;
}

export const fetchUserProfile = async () : Promise<UserProfileResponse> => {
    const response = await axiosClient.get(apiConfig.FETCH_USER_PROFILE.url);
    return response.data;
}

export const updateProfile = async (agencyId: string, payload: any) => {
    const response = await axiosClient.post(apiConfig.UPDATE_USER_PROFILE.url.replace('<agencyId>', agencyId), payload);
    return response.data;
}